import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadApoService {

  constructor(
    private http: HttpClient
  ) { }

  uploadApoFile(file: Blob) {
    const formData = new FormData();
    formData.append("file", file);

    return this.http.post(`${environment.apiUrl}/apo-upload`, formData).pipe(map((res: any) => {
      const apoUpload: Record<string, any[]> = {};
      for (const vs of Object.keys(res.apoUpload)) {
        apoUpload[vs] = this.buildHasErrors(res.apoUpload[vs]);
      }
      return { apoUpload, warnings: res.warnings, totalOrders: res.totalOrders };
    }));
  }

  getApoUpload() {
    return this.http.get(`${environment.apiUrl}/apo-upload`).pipe(
      map((res: any) => {
        const apoUpload: Record<string, any[]> = {};
        for (const vs of Object.keys(res.apoUpload)) {
          apoUpload[vs] = this.buildHasErrors(res.apoUpload[vs]);
        }
        return { apoUpload, warnings: res.warnings ?? [], totalOrders: res.totalOrders ?? 0 };
      })
    );
  }

  updateApoUpload(orders: any[]) {
    const payload = orders.map((o: any) => ({
      id: o.id,
      to_plan: o.to_plan,
      lote_interno: o.lote_interno,
      demand_type: o.demand_type,
      last_day: o.last_day,
      blender: o.blender,
      packaging_machine: o.packaging_machine,
      weight: o.weight,
      packaging_quantity: o.packaging_quantity,
      product_nature: o.product_nature,
      loss_percent: o.loss_percent,
      production_time: o.production_time,
      quality_time: o.quality_time,
      packaging_time: o.packaging_time,
      total_time: o.total_time,
    }));
    return this.http.put(`${environment.apiUrl}/apo-upload`, payload);
  }

  getApoFile() {
    let url = `${environment.apiUrl}/apo-file`;
    return this.http.get(url).pipe(map(this.buildHasErrors));
  }

  getApoLogistics(params: any) {
    return this.http.post(`${environment.apiUrl}/apo-logistics/planificador`, params);
  }

  getApoLogisticsData(startDate: string) {
    return this.http.get(`${environment.apiUrl}/apo-logistics?fecha_inicio_blender=${startDate}`);
  }

  // apoUploadConfirm() {
  //   return this.http.post(`${environment.apiUrl}/apo-file/confirmar`, {});
  // }

  editApoFile(id: number, updateApo: any) {
    const { load_kanbanize, ...payload } = updateApo;
    return this.http.put(`${environment.apiUrl}/apo-logistics/${id}`, payload);
  }

  deleteApoFile(id: number, type: string) {
    return this.http.delete(`${environment.apiUrl}/apo-logistics/${id}`, { params: { type } });
  }

  // deleteAllOrders() {
  //   return this.http.post(`${environment.apiUrl}/apo-file/deleteAll`, {});
  // }

  recalculateApoLogistics(formParameters: any, apoLogistics: any) {
    let body = {
      formParameters,
      apoLogistics
    }
    return this.http.post(`${environment.apiUrl}/apo-logistics/recalculate`, body);
  }

  apoLogisticsConfirm(apoLogistics: any) {
    return this.http.post(`${environment.apiUrl}/apo-logistics/save_planning`, apoLogistics);
  }

  private buildHasErrors(items: any) {
    return items.map((item: any) => {
      if (item.errors?.producto || item.errors?.template || item.errors?.duplicate) {
        item.hasErrors = true;
        if (item.errors?.producto && !item.errors?.template && !item.errors?.duplicate) {
          item.errorsDesc = 'Error de producto';
        } else if (item.errors?.template && !item.errors?.producto && !item.errors?.duplicate) {
          item.errorsDesc = 'Error de plantilla';
        } else if (item.errors?.template && item.errors?.producto && !item.errors?.duplicate) {
          item.errorsDesc = 'Error de plantilla y de producto';
        } else if (!item.errors?.producto && !item.errors?.template && item.errors?.duplicate) {
          item.errorsDesc = 'Error de duplicados';
        } else if (item.errors?.producto && !item.errors?.template && item.errors?.duplicate) {
          item.errorsDesc = 'Error de producto y de duplicados';
        } else if (!item.errors?.producto && item.errors?.template && item.errors?.duplicate) {
          item.errorsDesc = 'Error de plantilla y de duplicados';
        } else if (item.errors?.template && item.errors?.producto && item.errors?.duplicate) {
          item.errorsDesc = 'Error de producto, plantilla y de duplicados';
        }
      }

      if (!item.isLimpieza) {
        item.identifier = item.product_number;
        item.description = item.product_description;
      } else if (item.isLimpieza) {
        item.identifier = item.limpieza_type;
        item.description = item.limpieza_description;
      }

      if (item.order_id === '') {
        item.order_id = '-'
      }

      if (item.lote === '') {
        item.lote = '-'
      }
      return item;
    });
  }

}
